module.exports = __webpack_public_path__ + "static/media/banner3.8036d9c8.jpg";